import React, { useEffect, useRef, useState } from 'react'
import { Button, Descriptions, Table } from 'antd'
import { PrinterOutlined } from '@ant-design/icons';
import { useReactToPrint } from 'react-to-print';
import { useSelector } from 'react-redux';
import TablePage from '../../../../../../components/pages/TablePage'
import PrintPlpDocument from './printPlp';
import moment from 'moment'

// API list mengembalikan bentuk flat (refNumber, kemasan, response, ...)
// fallback ke bentuk lama header/detil agar data lama tetap tampil
const getKemasan = (row) => row?.kemasan || row?.detil?.[0]?.kemasan || [];
const getKontainer = (row) => row?.kontainer || row?.detil?.[0]?.kontainer || [];
const pick = (row, flat, nested) => row?.[flat] ?? row?.header?.[nested] ?? row?.[nested];

const Detail = ({ data }) => {
    const kemasan = getKemasan(data);
    const kontainer = getKontainer(data);
    return (
        <div style={{ padding: 16 }}>
            <Descriptions size="small" bordered column={4}>
                <Descriptions.Item label="No PLP">{data?.response?.data?.nomorPlp || '-'}</Descriptions.Item>
                <Descriptions.Item label="Tgl PLP">{data?.response?.data?.tanggalPlp || '-'}</Descriptions.Item>
                <Descriptions.Item label="Tgl Dibuat">{(data?.createdAt && moment(data.createdAt).format("DD-MMM-YYYY")) || '-'}</Descriptions.Item>
                <Descriptions.Item label="No Surat">{pick(data, 'nomorSurat', 'nomorSurat') || '-'}</Descriptions.Item>
                <Descriptions.Item label="No BC 1.1">{pick(data, 'nomorBc11', 'nomorBc11') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Tgl BC 1.1">{pick(data, 'tanggalBc11', 'tanggalBc11') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Tgl Tiba">{pick(data, 'tanggalTiba', 'tanggalTiba') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Pemohon" span={4}>{pick(data, 'namaPemohon', 'namaPemohon') || '-'}</Descriptions.Item>
                <Descriptions.Item label="Angkut" span={4}>{pick(data, 'namaAngkut', 'namaAngkut') || '-'} ({pick(data, 'callSign', 'callSign') || '-'})</Descriptions.Item>
                <Descriptions.Item label="Kemasan" span={4}>
                    <Table
                        size="small"
                        pagination={false}
                        rowKey={(_, i) => i}
                        dataSource={kemasan || []}
                        columns={[
                            { title: 'Jenis Kemasan', dataIndex: 'jenisKemasan', key: 'jenisKemasan' },
                            { title: 'Jumlah Kemasan', dataIndex: 'jumlahKemasan', key: 'jumlahKemasan' },
                            { title: 'Nomor BL/AWB', dataIndex: 'nomorBlAwb', key: 'nomorBlAwb' },
                            { title: 'Tanggal BL/AWB', dataIndex: 'tanggalBlAwb', key: 'tanggalBlAwb' },
                        ]}
                    />
                </Descriptions.Item>
                <Descriptions.Item label="Kontainer" span={4}>
                    <Table
                        size="small"
                        pagination={false}
                        rowKey={(_, i) => i}
                        dataSource={(kontainer || []).filter((k) => k.nomorKontainer || k.ukuranKontainer || k.jenisMuat)}
                        columns={[
                            { title: 'Nomor Kontainer', dataIndex: 'nomorKontainer', key: 'nomorKontainer' },
                            { title: 'Ukuran Kontainer', dataIndex: 'ukuranKontainer', key: 'ukuranKontainer' },
                            { title: 'Jenis Muat', dataIndex: 'jenisMuat', key: 'jenisMuat' },
                        ]}
                    />
                </Descriptions.Item>
                <Descriptions.Item label="Respons" span={4}>{data?.response?.detail || data?.response?.result || '-'}</Descriptions.Item>
            </Descriptions>
        </div>
    );
};
export default () => { // eslint-disable-line
    const printRef = useRef();
    const [printRow, setPrintRow] = useState(null);
    const wantPrint = useRef(false);
    const { warehouseCache } = useSelector((state) => state.apps);
    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: `PLP_${printRow?.refNumber || printRow?.header?.refNumber || 'doc'}`,
        pageStyle: '@page { size: A4; margin: 12mm; } @media print { body { -webkit-print-color-adjust: exact; } }',
    });
    // cetak setelah printRow ter-render di dokumen tersembunyi
    useEffect(() => {
        if (printRow && wantPrint.current) {
            wantPrint.current = false;
            handlePrint();
        }
    });
    const doPrint = (row, e) => {
        e?.stopPropagation();
        wantPrint.current = true;
        setPrintRow({ ...row });
    };
    const printAction = (row) => (
        <Button shape="circle" type="link" title="Print PDF"
            icon={<PrinterOutlined />}
            onClick={(e) => doPrint(row, e)}
        />
    );
    const columns = [
        {
            selector: (row) => row?.refNumber || row?.header?.refNumber || row?.reff_number || '-',
            name: "Ref Number",
            id: 'refNumber'
        },
        {
            selector: (row) => row?.noVoyFlight || row?.header?.noVoyFlight || row?.no_voy_flight || '-',
            name: "Flight",
            id: 'noVoyFlight'
        },
        {
            selector: (row) => {
                const asal = row?.gudangAsal || row?.header?.gudangAsal || row?.gudang_asal || '-';
                const tujuan = row?.gudangTujuan || row?.header?.gudangTujuan || row?.gudang_tujuan || '-';
                return `${asal} → ${tujuan}`;
            },
            name: "Asal → Tujuan",
            id: 'rute'
        },
        {
            selector: (row) => getKemasan(row).reduce((sum, k) => sum + (Number(k.jumlahKemasan) || 0), 0) || row?.jml_kemas || '-',
            name: "Jml Kemas",
            id: 'jml_kemas'
        },
    ]
    return (
        <>
            <TablePage
                title={"Permohonan PLP"}
                url="api/v1/plp"
                actionPosition={'right'}
                actionWidth="90px"
                createPath="/tps/plp/permohonan/form"
                columns={columns}
                ExpandComponent={Detail}
                otherAction={printAction}
            />
            {/* dokumen tersembunyi (tetap ter-render agar bisa dicetak) */}
            <div style={{ overflow: 'hidden', height: 0 }}>
                <PrintPlpDocument ref={printRef} data={printRow} warehouses={warehouseCache} />
            </div>
        </>
    )
}